import { css } from '@fable/theme'
import { CreateReadingGoalButton } from './CreateReadingGoalButton'
import { getName } from 'utils'
import { useStats } from 'app/webview/pages/stats_profile/lib/ctx/stats'
import { useReadingGoals } from 'app/webview/pages/stats_profile/lib/ctx/reading_goals'
import { useStatsPermission } from 'app/webview/pages/stats_profile/lib/hooks'
import { FlexBox } from '@fable/components'
import { ReadingGoalsTabs } from './ReadingGoalsTabs'
import { ReadingGoalsContent } from './ReadingGoalsContent'
import { StatsProfileBox } from '../shared/stats_profile_box'
import capitalize from 'lodash/capitalize'
import { useStatsTheme } from '../../theme/ctx'

export const ReadingGoals = () => {
  const [isSelfView, stats, year] = useStats((s) => [
    s.isSelfView,
    s.stats,
    s.year,
  ])
  const [createReadingGoal, period] = useReadingGoals((s) => [
    s.createReadingGoal,
    s.period,
  ])
  const { isAndroid, isPlusUser } = useStatsPermission()
  const theme = useStatsTheme((s) => s.theme)
  const statsUserName = getName(stats?.user?.display_name)?.first
  const firstName = statsUserName ? `${capitalize(statsUserName)}'s` : ''
  const isPrior2025 = year < 2025
  const isFreeViewingOther = !isSelfView && !isPlusUser
  const isYearOnly = isFreeViewingOther || isPrior2025 || isAndroid

  return (
    <StatsProfileBox
      id="reading-goals"
      data-testid="stats-reading-goals"
      text={{
        top: isSelfView ? 'Your' : firstName,
        main: 'Reading goal',
        bottom: (
          <span
            className={css`
              color: ${theme.colors.section.textSecondary};
            `}
          >
            progress
          </span>
        ),
        infoText: isYearOnly ? (
          'Your active reading goals are public unless you make your stats private.'
        ) : (
          <>
            Your weekly and monthly goals will automatically reset every Sunday
            and on the 1st of each month at 12am.
            <br />
            <br />
            Your active reading goals are public unless you make your stats
            private.
          </>
        ),
      }}
      actions={
        isPrior2025 || !isSelfView || isAndroid ? null : (
          <CreateReadingGoalButton
            onClick={() => createReadingGoal({ period_type: period })}
          />
        )
      }
    >
      <FlexBox
        className={css`
          margin-top: 16px;
          width: 100%;
          gap: 14px;
        `}
        flexDirection="column"
      >
        {isYearOnly ? null : <ReadingGoalsTabs />}
        <ReadingGoalsContent />
      </FlexBox>
    </StatsProfileBox>
  )
}
